module.exports = __webpack_public_path__ + "img/strict-persona.5da67e75.svg";